import { exposeRequireContext } from 'live/expose'
// import './__tests__/exampleSheduleActionType/SheduleActionType'

// #see: https://webpack.js.org/guides/dependency-management/#requirecontext
const req = require.context(
    './', // require from current directory
    true, // recursive
    /^(?!.*__tests__.*)^(?!.*\.stories\.*)^(?!.*Spec.js)^(?!.*worker.js)^(?!.*__mocks__.*\.js)((.*\.([t|j]sx?\.*))[^.]*$)/
)

exposeRequireContext(req, 'plugin-reports-maker/shared/')
